module.exports = __webpack_public_path__ + "img/dot-under-line.87f80590.svg";